export const font_style = {
  fontFamily: "Open Sans Hebrew",
};

export const small_style = {
  fontFamily: "Open Sans Hebrew",
  color: "#828282",
  fontSize: 13,
};

export const small_style_tmp = {
  fontFamily: "Open Sans Hebrew",
  color: "#828282",
  fontSize: 13,
  direction: "rtl",
  textAlign: "right",
  display: "inline-flex",
};

export const trash_style = {
  fontFamily: "Open Sans Hebrew",
  color: "#65AC45",
  fontSize: 17,
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  float: "right",
  padding: "15px 100px",
  position: "relative",
};

export const green_style = {
  fontFamily: "Open Sans Hebrew",
  background: "#65AC45",
  color: "#FFFFFF",
};

export const gray_style = {
  fontFamily: "Open Sans Hebrew",
  background: "#65AC45",
  color: "#FFFFFF",
  opacity: 0.5,
};

export const paper_style = {
  marginTop: 30,
  display: "flex",
  padding: 20,
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
};

export const buttons_style = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  float: "right",
};

export const person_info_style = {
  textAlign: "right",
  alignSelf: "stretch",
  lineHeight: 0.7,
};

export const after_tool = {
  marginTop: 50,
};

export const spacer = {
  marginTop: 15,
};
